// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mgl-version[data-v-2f17db25] {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}", ""]);
// Exports
module.exports = exports;
